import { Update } from '@ngrx/entity';
import { UpdateNum } from '@ngrx/entity/src/models';
import { createAction, props } from '@ngrx/store';
import { Notification } from './notifications.models';

export enum NotificationsActionTypes {
  Add = '[Notifications API] Add Notification',

  DeleteOne = '[Notifications Widget] Delete Notification',
  DeleteOneSuccess = '[Notifications API] Delete Notification Success',
  DeleteOneFail = '[Notifications API] Delete Notification Fail',

  Load = '[Notifications Widget] Load Notifications',
  LoadSuccess = '[Notifications API] Load Notifications Success',
  LoadFail = '[Notifications API] Load Notifications Fail',

  MarkAsRead = '[Notifications Widget] Mark As Read',
  MarkAsReadSuccess = '[Notifications API] Mark As Read Success',
  MarkAsReadUndo = '[Notifications API] Mark As Read Undo',

  MarkAsUnread = '[Notifications Widget] Mark As Unread',
  MarkAsUnreadSuccess = '[Notifications API] Mark As Unread Success',
  MarkAsUnreadUndo = '[Notifications API] Mark As Unread Undo',

  ToggleUnread = '[Notifciations Widget] ToggleUnread',

  DownloadReport = '[Notifications Widget] Download Report'
}

export const add = createAction(NotificationsActionTypes.Add, props<{notification: Notification}>())

export const deleteOne = createAction(NotificationsActionTypes.DeleteOne, props<{id: number}>());

export const deleteOneSuccess = createAction(
  NotificationsActionTypes.DeleteOneSuccess,
  props<{id: number}>()
);

export const deleteOneFailure = createAction(NotificationsActionTypes.DeleteOneFail, props<{ error: any }>());

export const load = createAction(NotificationsActionTypes.Load);

export const loadNotificationsSuccess = createAction(
  NotificationsActionTypes.LoadSuccess,
  props<{ notifications: Notification[] }>()
);

export const loadNotificationsFailure = createAction(NotificationsActionTypes.LoadFail, props<{ error: any }>());

export const markAsRead = createAction(NotificationsActionTypes.MarkAsRead, props<{notification: UpdateNum<Notification>}>());

export const markAsReadSuccess = createAction(
  NotificationsActionTypes.MarkAsReadSuccess,
);

export const markAsReadUndo = createAction(NotificationsActionTypes.MarkAsReadUndo, props<{ id: number }>());

export const markAsUnread = createAction(NotificationsActionTypes.MarkAsUnread, props<{notification: UpdateNum<Notification>}>());

export const markAsUnreadSuccess = createAction(
  NotificationsActionTypes.MarkAsUnreadSuccess,
);

export const markAsUnreadUndo = createAction(NotificationsActionTypes.MarkAsUnreadUndo, props<{ id: number }>());

export const toggleUnread = createAction(NotificationsActionTypes.ToggleUnread, props<{unread: boolean}>());

export const downloadReport = createAction(NotificationsActionTypes.DownloadReport, props<{reportId: number, filename: string}>());
